<!-- Change Billing Name Modal  -->
<p-dialog [(visible)]="showModel" [resizable]="false" appendTo="body" [modal]="true"
  [breakpoints]="{'767px': '100vw'}" [style]="{width: '500px'}" styleClass="no-header-modal"
  aria-label="change-billing-name-dialog" data-testid="change-billing-name-dialog">

  <ng-template pTemplate="header" styleClass="hidden"></ng-template>
  <ng-template pTemplate="content" styleClass="p-0">

    <form [formGroup]="billingNameForm" data-testid="billing-name-form">
      <!-- Header -->
      <div class="p-3 flex align-items-center justify-content-between relative border-bottom-1 border-300" data-testid="dialog-header">
        <h2 class="mb-0 text-sm"> {{'POS.MEMBERSHIP_ADDON.CHANGE_BILLING_NAME' | translate}}</h2>
        <div class="fa fa-times text-xl text-600 cursor-pointer" (click)="ClosePopup()" 
          aria-label="close-dialog" data-testid="close-billing-name-dialog-button"></div>
      </div>
      <!-- Header -->


      <!-- Modal Content -->
      <div class="surface-100 px-3 py-5" data-testid="billing-name-content">

        <!-- Column -->
        <label class="font-medium text-700 text-xs mb-2 block uppercase" for="billing-name-input"> {{'POS.MEMBERSHIP_ADDON.NEW_BILLING_NAME'| translate}}</label>
        <input type="text" class="text-sm w-full" formControlName="billing_name" pInputText id="billing-name-input"
          placeholder="Enter the new billing name" aria-label="new-billing-name" data-testid="billing-name-input" />
        <app-error-msg *ngIf="billingNameFormControl.dirty && billingNameFormControl.invalid"
          [errors]="billingNameFormControl.errors" [fieldLabel]="'POS.MEMBERSHIP_ADDON.NEW_BILLING_NAME' | translate"
          data-testid="billing-name-error">
        </app-error-msg>
        <!-- Column -->

      </div>
      <!-- Modal Content -->


      <!-- Modal Footer -->
      <div class="surface-0 border-top-1 border-300 p-3" data-testid="dialog-footer">
        <p-button [disabled]="billingNameFormControl.invalid" styleClass="w-full"
          label="{{'POS.MEMBERSHIP_ADDON.NEW_BILLING_NAME' | translate}}" (click)="ClosePopup()"
          aria-label="save-billing-name" data-testid="save-billing-name-button"></p-button>
      </div>
      <!-- Modal Footer -->

    </form>

  </ng-template>

</p-dialog>
<!-- Change Billing Name Modal  -->